'use strict';
'use es6';

/** @module debounce */
/** Ensures a given task doesn't fire so often as to brick browser
 * performance. Returns a function, that, as long as it continues
 * to be invoked, will not be triggered.
 *
 * Usage:
 *   // Place your code within {}
 *   const myEfficientFn = debounce(() => {}, 250);
 *   window.addEventListener('resize', myEfficientFn);
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (func, wait, immediate) {
  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(undefined, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(undefined, args);
    }
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/wtDebounce.js
// module id = 576
// module chunks = 3 4